<template>
  <v-container class="px-0 py-0" fluid>
    <v-row>
      <v-col>
        <MeasInstForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MeasInstForm from '@/components/organisms/master/form/MeasInstForm'

export default {
  name: 'MeasInstPage',

  components: {
    MeasInstForm,
  },
}
</script>
